import { TruncatedText } from "../../../utils/truncated_text";
import type { ColumnTypeFn } from "../types";

export const textType: ColumnTypeFn = (value) => {
  if (value == null) return <span className="text-muted">-</span>;
  return <TruncatedText text={String(value)} />;
};
